/* eslint-disable react/require-default-props */
import React, { useMemo, useState } from 'react';
import PaginatedSelect from '../PaginatedSelect';
import { usePaginatedBuildings } from './usePaginatedBuildings';
export default function BuildingSelector({ className, value, onChange, placeholder = 'Select a building...', variant = 'inline' }) {
    const [searchFilter, setSearchFilter] = useState('');
    const { data, isLoading, isError, error, fetchNextPage, hasNextPage, isFetchingNextPage } = usePaginatedBuildings({
        filter: searchFilter,
        pageSize: 20
    });
    // Flatten paginated data into a single array
    const buildings = useMemo(() => {
        return (data === null || data === void 0 ? void 0 : data.pages.flatMap((page) => page.data)) || [];
    }, [data]);
    // Transform buildings into Select options
    const options = buildings.map((building) => ({
        value: building.value.toString(),
        label: building.label
    }));
    // Add current value to options if it's not already in the list
    const allOptions = useMemo(() => {
        if (value && !buildings.find((building) => building.value === value.value)) {
            return [{ value: value.value.toString(), label: value.label }, ...options];
        }
        return options;
    }, [options, value, buildings]);
    const handleChange = (selectedValue) => {
        if (!selectedValue) {
            onChange(null);
            return;
        }
        // First try to find in the loaded buildings
        let selectedBuilding = buildings.find((building) => building.value.toString() === selectedValue);
        // If not found and we have a current value with the same ID, use that
        if (!selectedBuilding && value && value.value.toString() === selectedValue) {
            selectedBuilding = value;
        }
        onChange(selectedBuilding || null);
    };
    const handleSearch = (searchTerm) => {
        setSearchFilter(searchTerm);
    };
    const handleLoadMore = () => {
        if (hasNextPage && !isFetchingNextPage) {
            void fetchNextPage();
        }
    };
    if (isError) {
        return (React.createElement("div", { className: className },
            React.createElement("span", null,
                "Error loading buildings: ", error === null || error === void 0 ? void 0 :
                error.message)));
    }
    return (React.createElement(PaginatedSelect, { className: className, options: allOptions, value: (value === null || value === void 0 ? void 0 : value.value.toString()) || '', onChange: handleChange, onSearch: handleSearch, onLoadMore: handleLoadMore, hasMore: hasNextPage, isLoading: isLoading, isLoadingMore: isFetchingNextPage, placeholder: placeholder, searchable: true, variant: variant, label: "Building" }));
}
